import { useCallback } from 'react';

import { useGetInvitationsQuery } from './__generated__/getInvitations.generated';

export const useInvitationsList = () => {
	const { data, refetch, loading, error, client } = useGetInvitationsQuery();

	const refetchWithQueries = useCallback(() => {
		return Promise.all([
			client.refetchQueries({ include: ['GetInvitationsFromFamilyCaregivers'] }),
			refetch(),
		]);
	}, [client, refetch]);

	return { invitations: data, refetch: refetchWithQueries, loading, error };
};
